import type { en } from "./en.ts";

export const fr: typeof en = {
    AuthenticatedLayout: {
        title: "Workleap",
        agent: "Agent",
        jumpTo: "Aller à",
        openNavigation: "Ouvrir la navigation",
        closeNavigation: "Fermer la navigation",
        primaryNavigation: "Principale",
        openUserMenu: "Ouvrir le menu de l'espace de travail et de l'utilisateur",
        viewProfile: "Voir le profil",
        settings: "Paramètres",
        workspace: "Espace de travail",
        currentWorkspace: "Espace de travail actuel",
        switchWorkspaceError: "Impossible de changer d'espace de travail. Veuillez réessayer.",
        loadingWorkspaces: "Chargement des espaces de travail",
        switchingWorkspace: "Changement d'espace de travail",
        logout: "Se déconnecter",
        resizeAgentPanel: "Redimensionner le panneau de l'agent"
    },
    CreateMenu: {
        create: "Créer",
        newSurvey: "Nouveau sondage",
        newReviewCycle: "Nouveau cycle d'évaluation"
    },
    SidebarLayout: {
        navigation: "Sections",
        closeMenu: "Fermer le menu"
    },
    TabsLayout: {
        tabs: "Onglets"
    },
    PageTitleHeading: {
        openMenu: "Ouvrir le menu"
    },
    ModuleErrorBoundary: {
        title: "Une erreur est survenue",
        description: "Nous n'avons pas pu charger cette page. Vous pouvez réessayer ou retourner à l'accueil.",
        retry: "Réessayer",
        goHome: "Retour à l'accueil"
    },
    NotFoundPage: {
        title: "Page introuvable",
        code: "404",
        description: "Cette page est introuvable.",
        backHome: "Retour à l'accueil"
    },
    OrganizationAccessPage: {
        title: "Non disponible",
        heading: "Pas encore disponible pour votre organisation",
        body: "Votre organisation n'a pas accès à la nouvelle expérience Workleap. Vous pouvez continuer à utiliser l'expérience Workleap classique.",
        backToWorkleap: "Retour à Workleap"
    },
    RootErrorBoundary: {
        title: "Une erreur est survenue",
        description: "L'application n'a pas pu démarrer. Essayez de rafraîchir la page ou de retourner à l'accueil.",
        goHome: "Retour à l'accueil"
    },
    BootstrappingRoute: {
        loading: "Chargement"
    },
    unmanagedMutationErrors: {
        toastMessage: "Une erreur est survenue. Veuillez réessayer."
    },
    CommandMenu: {
        placeholder: "Aller à",
        noResults: "Aucun résultat ne correspond à votre recherche.",
        searching: "Recherche...",
        dialogLabel: "Palette de commandes",
        sections: {
            people: "Personnes",
            teams: "Équipes"
        },
        memberCount_one: "{{count}} membre",
        memberCount_other: "{{count}} membres",
        footer: {
            navigate: "naviguer",
            open: "ouvrir",
            escToClose: "esc pour fermer"
        }
    }
};
